<script>
import moment from 'moment';
import { AxiosHelper } from '@src/utils/utils'
import {Chart} from 'highcharts-vue'

function pieOption(containerID) {
	return {
		chart : {
			// renderTo : containerID,
			type: "pie",
			margin : 0
		},
		credits : { enabled : false},
		title : { text : ''},
			plotOptions: {
				pie: {
					allowPointSelect: false,
					dataLabels: {
						enabled: true,
						useHTML : true,
						formatter : function() {
							var tag = "<div style='border:2px solid " + this.point.color + "'>";
							tag += this.point.name + "<br/>" + this.y.toComma() + '원';
							tag += "</div>";
							return tag;
						}
					}
				}
			},
		series : [{
			name : "",
			data : []
		}]
	}
}

export default {
  components: { highcharts: Chart },
  props: {
		prevStartTime : {
			type: String,
			required: true
		},
		prevEndTime : {
			type: String,
			required: true
		},
		startTime : {
			type: String,
			required: true
		},
		endTime : {
			type: String,
			required: true
		},
  },
  data() {
    return {
			prevConfig : {},
			curConfig : {}

    }
  },
  created() {
	},
  mounted() {},
  methods: {
    show: function(time) {
			
			this.$refs.modal.show()
			
			const prevOption = pieOption("prevMonth");
			const prevMonth = moment(new Date(this.prevStartTime.toInt())).format('M');
			AxiosHelper.get(`/api/cardsms/pay/stat/${this.prevStartTime}/${this.prevEndTime}`).then(ret => {
				var sum = 0;
				for(var i = 0; i < ret.data.length; i++) {
					var item = ret.data[i];
			    	prevOption.series[0].name = `${prevMonth}월 사용금액`;
			    	prevOption.series[0].data.push({
			    		name: item.cate_name,
			    		y: item.sum
			    	});
			    	sum += item.sum;
				}
				prevOption.title.text = `${prevMonth}월<br/>${sum.toComma()}원`;
				
				this.prevConfig = prevOption;
			});


			const curOption = pieOption("curMonth");
			const curMonth = moment(new Date(this.startTime.toInt())).format('M');
			AxiosHelper.get(`/api/cardsms/pay/stat/${this.startTime}/${this.endTime}`).then(ret => {
				var sum = 0;
				for(var i = 0; i < ret.data.length; i++) {
					var item = ret.data[i];
					curOption.series[0].name = `${curMonth}월 사용금액`;
					curOption.series[0].data.push({
			    		name: item.cate_name,
			    		y: item.sum
			    	});
					sum += item.sum;
				}
				curOption.title.text = `${curMonth}월<br/>${sum.toComma()}원`;

				this.curConfig = curOption;
			});

		},
		

    hidden() {
			this.$refs.modal.hide()
      this.$emit('hidden');
    },
  },
}
</script>

<template>
	<C.Modal ref="modal" title='전월/현재월 지출금액 비교'
		dialog-class-name="modal-dialog-scrollable modal-lg"
	>
		<C.Row>
			<C.Col lg="6">
				<highcharts :options="prevConfig"></highcharts>
			</C.Col>
			<C.Col lg="6">
				<highcharts :options="curConfig"></highcharts>
			</C.Col>
		</C.Row>
	</C.Modal>
</template>
